import { z } from "zod";
export const MEMBER_ROLES = ["viewer", "manager", "admin", "custom"];
export const memberRoleSchema = z.enum(MEMBER_ROLES);
export const MemberRoleEnum = {
    VIEWER: "viewer",
    MANAGER: "manager",
    ADMIN: "admin",
    CUSTOM: "custom",
};
